import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Popup } from "semantic-ui-react";

interface IContactCardDetails {
  fieldName: string;
  fieldValue: JSX.Element | string;
  icon: IconProp;
  className?: string;
}

export function ContactCardDetails({ fieldName, fieldValue, icon, className }: IContactCardDetails) {
  return (
    <Popup
      trigger={
        <div className={classNames("tw-flex tw-flex-wrap", className)}>
          <FontAwesomeIcon icon={icon} className='tw-mr-3 tw-mt-1' aria-hidden='true' />
          <span className='sr-only'>{fieldName}</span>
          {fieldValue}
        </div>
      }
      content={fieldName}
      position='left center'
      inverted
      hoverable
      mouseEnterDelay={500}
    />
  );
}
